import { Building, User, ShoppingCart, Shield, Calculator, FileText } from 'lucide-react';
import { DevAccount } from '../types';

// Auth-related constants
export const AUTH_STORAGE_KEY = 'jwt';

export const AUTH_ROUTES = {
  LOGIN: '/login',
  LOGOUT: '/logout',
  REGISTER: '/register',
  AUTO_LOGIN: '/autologin',
  DASHBOARD: '/dashboard',
  HOME: '/',
} as const;

// Auth roles are now fetched dynamically from the backend via rolesPermissionsService
// These constants are kept for backward compatibility and dev accounts only
export const AUTH_ROLES = {
  SUPER_ADMIN: 'super_admin',
  TRAMITADORA: 'tramitadora',
  CONTADOR: 'contador',
  ESCRIBANO_EXTERNO: 'escribano_externo',
  // Note: VENDEDOR and COMPRADOR are contextual roles within tramites, not direct user roles
  VENDEDOR: 'vendedor',
  COMPRADOR: 'comprador',
} as const;

// Development accounts for testing
// Note: Vendedor/Comprador accounts removed as these are contextual roles within tramites
export const DEV_ACCOUNTS: DevAccount[] = [
  {
    role: AUTH_ROLES.SUPER_ADMIN,
    email: 'admin@escribaniapasserini.com.ar',
    password: 'SuperAdmin.1',
    label: 'Super Administrador',
    icon: Shield
  },
  {
    role: AUTH_ROLES.TRAMITADORA,
    email: 'tramites@escribaniapasserini.com.ar',
    password: 'Escribania.1',
    label: 'Tramitadora',
    icon: Building
  },
  {
    role: AUTH_ROLES.CONTADOR,
    email: 'contador@escribaniapasserini.com.ar',
    password: 'Contador.1',
    label: 'Contador',
    icon: Calculator
  },
  {
    role: AUTH_ROLES.ESCRIBANO_EXTERNO,
    email: 'escribano@escribaniapasserini.com.ar',
    password: 'Escribano.1',
    label: 'Escribano Externo',
    icon: FileText
  }
];

// Auth API endpoints
export const AUTH_ENDPOINTS = {
  LOGIN: '/login',
  LOGOUT: '/logout',
  USER: '/user',
  USER_PASSWORD: '/user/password',
  REGISTER: '/register',
  CHANGE_PASSWORD: '/change-password',
  NOTIFY_CREDENTIALS: '/notify/credentials',
} as const;

// Auth error messages
export const AUTH_ERROR_MESSAGES = {
  INVALID_CREDENTIALS: 'Credenciales inválidas',
  SESSION_EXPIRED: 'Sesión expirada',
  NETWORK_ERROR: 'Error de conexión',
  UNAUTHORIZED: 'No autorizado',
  TOKEN_MISSING: 'No se recibió token de autenticación',
  INVALID_RESPONSE: 'Respuesta del servidor inválida',
  STORAGE_ERROR: 'Error al guardar la sesión localmente',
  LOGIN_ERROR: 'Error al iniciar sesión',
  USER_DATA_ERROR: 'Error al obtener datos del usuario',
  CONTEXT_ERROR: 'useAuth debe estar dentro del proveedor AuthContext',
} as const;
